import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DraftValidationModule, TrademeCoreUiPipeModule } from '@classifieds-sell/shared';
import { DraftFacade, UserFacade } from '@classifieds-sell/state';
import { TmContactModalModule, TrademeCoreUiModule } from '@classifieds-sell/trademe-core-ui';
import { TgButtons2Module, TgCheckboxModule, TgGridModule, TgInputModule, TgSelectModule } from '@trademe/tangram';
import { DisallowEmptyIfPipe } from './disallow-empty-if-bids.pipe';
import { MotorsListingDetailsContactSectionComponent } from './motors-listing-details-contact-section.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgButtons2Module,
        TgCheckboxModule,
        TgGridModule,
        TgInputModule,
        TgSelectModule,
        LayoutModule,
        TmContactModalModule,
        TrademeCoreUiModule,
        DraftValidationModule,
        TrademeCoreUiPipeModule
    ],
    declarations: [MotorsListingDetailsContactSectionComponent, DisallowEmptyIfPipe],
    providers: [DraftFacade, UserFacade],
    exports: [MotorsListingDetailsContactSectionComponent]
})
export class MotorsListingDetailsContactSectionModule {}
